module.exports = __webpack_public_path__ + "static/media/Inertia_theory_q4.c1762035.mp4";